<template>
  <div class="page">
    <!-- <br> -->
    <div class="textLayout"  style="background:#fff">
      <!-- <yd-cell-group title="组团社名称（必填）">
        <yd-cell-item>
            <yd-input slot="right" v-model="clubName"></yd-input>
        </yd-cell-item>
      </yd-cell-group> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 组团社名称（必填）</div>
        <div class="inp">
           <van-field
            v-model="clubName"
            placeholder="请填写组团社名称"
            
          />
        </div>
      </div>
      <!-- <yd-cell-group title="组团社电话（必填）">
        <yd-cell-item>
            <yd-input slot="right" v-model="phone"></yd-input>
        </yd-cell-item>
      </yd-cell-group> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 组团社电话（必填）</div>
        <div class="inp">
           <van-field
            v-model="phone"
            placeholder="请填写组团社电话（必填）"
            
          />
        </div>
      </div>
      <!-- <yd-cell-group title="微信号">
        <yd-cell-item>
            <yd-input slot="right" v-model="clubWeiXin"></yd-input>
        </yd-cell-item>
      </yd-cell-group> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 微信号</div>
        <div class="inp">
           <van-field
            v-model="clubWeiXin"
            placeholder="请填写微信号"
            
          />
        </div>
      </div>
      <!-- <yd-cell-group title="联系邮箱">
        <yd-cell-item>
            <yd-input slot="right" v-model="clubEmail"></yd-input>
        </yd-cell-item>
      </yd-cell-group> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 联系邮箱</div>
        <div class="inp">
           <van-field
            v-model="clubEmail"
            placeholder="请填写联系邮箱"
            
          />
        </div>
      </div>
      <!-- <div class="uploadPictureTitleLayout">
        组团社LOGO
      </div>
      <div class="pictureAddLayout">
        <Uploader v-bind:url="remoteUrl"
                  v-bind:data="formData"
                  v-bind:type=1
                  v-bind:defaultImg=poster
                  @success="uploadSuccess($event)"
                  @error="uploadError($event)"
                  v-if="initOssEnd">
        </Uploader>
      </div> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 组团社LOGO</div>
        <div class="inp">
            <div class="pictureAddLayout">
                <Uploader v-bind:url="remoteUrl"
                          v-bind:data="formData"
                          v-bind:type=1
                          v-bind:defaultImg=poster
                          @success="uploadSuccess($event)"
                          @error="uploadError($event)"
                          v-if="initOssEnd">
                </Uploader>
              </div>
        </div>
      </div>
      <!-- <div class="uploadPictureTitleLayout">
        价格上浮比例
      </div>
      <div style="background-color:#f6f6f6;margin-bottom:8px;margin-top:4px">
        <yd-spinner max="100" min="0" width="150px" height="40px" v-model="ratio"></yd-spinner>
      </div> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div>价格上浮比例</div>
        <div class="inp">
            <div style="background-color:#ffff;margin-bottom:8px;margin-top:4px">
              <yd-spinner max="100" min="0" width="150px" height="40px" v-model="ratio"></yd-spinner>
            </div>
        </div>
      </div>
      <!-- <yd-cell-group title="备注">
        <yd-cell-item>
          <yd-textarea slot="right" v-model="remark" placeholder="" maxlength="1000"></yd-textarea>
        </yd-cell-item>
      </yd-cell-group> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 备注</div>
        <div class="inp">
           <van-field
            v-model="remark"
            placeholder="备注"
            rows="4"
            type="textarea"
            autosize
          />
        </div>
      </div>
      <div class="uploadPictureTitleLayout">
        选择用户
      </div>
      <!-- <div class="uploadPictureTitleLayout" v-if='personArray && personArray.length>0'>
        添加的用户
      </div> -->
      <div style="margin-top:6px" v-if="personArray && personArray.length>0">
        <ul>
        <div v-for="(person, index) in personArray" :key="index">
          <li>
            <div class="personCellLayout">
              <div class="personCellPortrait">
                <img :src="(person.img_path ? person.img_path : person.image)|cutFitWidthImg('90w_90h')">  
              </div>
              <div class="personNameLayout">
                <p>{{person.nickname ? person.nickname : person.name}}</p>
                <p v-if="person.loginName && person.loginName.length < 15">{{person.loginName}}</p>
              </div >
              <div class="personSelectedLayout">
                <button @click="deletePersonAction(person,index)">删除</button>
              </div>
            </div>
            <div class="singleLineLayout"></div>
          </li>
        </div>
        </ul>
      </div>
      <div style="margin-top:8px">
        <yd-button size="large" type="hollow" @click.native="addUserAction()">添加组团社管理员</yd-button>
      </div>
      <div class="confirmButtonLayout">
        <yd-button size="large" type="primary" @click.native="submitGroupAction()">确   定</yd-button>
      </div>
      <div class="pop" v-if="showUserList">
        <user-list @getPersonFromUserList="getPerson"></user-list>
      </div>
    </div>
  </div>
</template>

<script>
import Uploader from '@/pages/common/Uploader'
import UserList from '@/pages/common/UserList'
import appService from '@/services/request/appService'
import { cutFitWidthImg } from "@/services/libs/utils"
import store from 'store'
export default {
  name: 'EditGroup',
  components:{
    Uploader,UserList
  },
  data() {
    return {
      mine: {},
      groupInfo: {},
      poster: '',
      clubName: '',
      phone: '',
      clubWeiXin: '',
      clubEmail: '',
      ratio: 0,
      remark: '',
      personArray: [],
      initOssEnd: false,
      remoteUrl: '',
      formData: {},
      showUserList: false,
    }
  },
  mounted: function(){
    this.$nextTick(function() {
      this.mine = store.get('mine') || {}
      this.groupInfo = store.get('editGroupInfo')
      if(this.$route.query.edit && this.groupInfo) {
        document.title = '编辑组团社'
        if(this.groupInfo) {
          this.poster = this.groupInfo.groupImage
          this.clubName = this.groupInfo.groupName
          this.phone = this.groupInfo.groupPhone
          this.ratio = this.groupInfo.ratio
          if(this.groupInfo.ext) {
            this.remark = this.groupInfo.ext
          }
          if(this.groupInfo.users) {
            this.personArray = JSON.parse(this.groupInfo.users)
          }
        }
      }else {
        document.title = '新增组团社'
      }
      store.set('editGroupInfo', '')
      this.initOssParams();
    })
  },
  methods:{
    initOssParams() {
      appService
        .getOssParams()
        .then(
          result => {
            var ossInfo = result
            var key = "h5/" + this.$route.query.iid + "_" + new Date().getTime()
            this.remoteUrl = "https://fimage.oss-cn-shenzhen.aliyuncs.com/"
            this.formData = {
              key: key,
              policy: ossInfo.policy,
              OSSAccessKeyId: ossInfo.accessKeyId,
              success_action_status: "200", //让服务端返回200,不然，默认会返回204
              signature: ossInfo.sign,
              expire_time: ossInfo.expireTime
            };
            this.initOssEnd = true
          },
        error => {}
      );
    },
    uploadSuccess(res) {
      if(res && res.previewUrl) {
        this.poster = res.previewUrl
      }
    },
    uploadError(res) {
      console.log("上传失败");
    },
    getPerson(person) {
      this.showUserList = false
      if(person) {
        var containPerson = false
        try{
          this.personArray.forEach(function(item,index){
            if(person.uid == item.uid) {
              containPerson = true
              throw new Error('EndIterative')
            }
          });
        }catch(e){
          if(e.message != "EndIterative") throw e;
        }
        if(containPerson) {
          this.$dialog.toast({
            mes: '您已添加过该用户',
            timeout: 1000,
          });
        }else {
          if(!containPerson) this.personArray.push(person)
        }
      }
    },
    addUserAction() {
      this.showUserList = true
    },
    deletePersonAction(person,index) {
      // var index = this.personArray.indexOf(person)
      this.personArray.splice(index, 1)
    },
    submitGroupAction() {
      if(!this.clubName) {
        this.$dialog.toast({
          mes: '请填写组团社名称',
          timeout: 1000,
        })
        return
      }
      if(!this.phone) {
        this.$dialog.toast({
          mes: '请填写组团社电话',
          timeout: 1000,
        })
        return
      }
      if(this.groupInfo) {
        this.editGroupClub();
      }else {
        this.addGroupClub();
      }
    },
    addGroupClub() {
      var usersJson = ''
      if(this.personArray && this.personArray.length>0) {
        usersJson = JSON.stringify(this.personArray)
      }
      appService
        .addGroupClub({
          iid: this.$route.query.iid,
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          groupName: this.clubName, 
          groupPhone: this.phone,
          wechatNo: this.clubWeiXin,
          email: this.clubEmail,
          groupImage: this.poster,
          users: usersJson,
          ratio: this.ratio,
          ext: this.remark,
        })
        .then(data => {
          this.$dialog.toast({
            mes: '添加组团社成功',
            timeout: 1500,
            icon: 'success'
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500);
        }, error => {
          var errorStr = '添加失败'
          if (error && error.sub_msg) {
              errorStr = error.sub_msg
          }
          this.$dialog.toast({
            mes: errorStr,
            timeout: 1500,
            icon: 'error',
          });
        })
    },
    editGroupClub() {
      var usersJson = ''
      if(this.personArray && this.personArray.length>0) {
        usersJson = JSON.stringify(this.personArray)
      }
      appService
        .updateGroupClub({
          id: this.groupInfo.id,
          iid: this.$route.query.iid,
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          groupName: this.clubName, 
          groupPhone: this.phone,
          wechatNo: this.clubWeiXin,
          email: this.clubEmail,
          groupImage: this.poster,
          users: usersJson,
          ratio: this.ratio,
          ext: this.remark,
        })
        .then(data => {
          this.$dialog.toast({
            mes: '编辑组团社成功',
            timeout: 1500,
            icon: 'success'
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500);
        }, error => {
          var errorStr = '编辑失败'
          if (error && error.sub_msg) {
              errorStr = error.sub_msg
          }
          this.$dialog.toast({
            mes: errorStr,
            timeout: 1500,
            icon: 'error',
          });
        })
    },
  }
}
</script>

<style scoped lang="less">
.page{
  font-size: 0.28rem;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.inp{
  & /deep/ textarea{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
    border-radius: 5px;
    padding: 3px;
    box-sizing: border-box;
  }
  & /deep/ input{
    // box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
    border-radius: 5px;
    padding: 3px;
    box-sizing: border-box;
  }
}
.uploadPictureTitleLayout{
  position: relative;
  text-align: left;
  color: #888;
  font-family: arial,sans-serif;
  font-size: .28rem;
  font-weight: 100;
  padding: 0.05rem .24rem 0.05rem;
  z-index: 1;
}
.pictureAddLayout{
  display: flex;
  position: relative;
  width: 40vw;
  height: 40vw;
  background-color: white;
  margin: 6px 16px;
}
.yd-btn-block{
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 12px;
  width: calc(100% - 32px);
  margin-top: 2px;
}
.personCellLayout{
  display: flex;
  width: 100%;
  height: 60px;
  background-color: white;
}
.personCellLayout .personCellPortrait{
  position: relative;
  display: block;
  width: 40px;
  height: 40px;
  margin: auto 12px;
  margin-right: 2px;
  border-radius: 50%;
  object-fit: cover;
  background-color: lightgray;
}
.personCellLayout img{
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background-color: lightgray;
}
.personCellLayout .personNameLayout{
  position: relative;
  float: left;
  text-align: left;
  justify-content: center;
  width: 60%;
  margin: auto 2px; 
  vertical-align: middle;
  padding-left: 2px;
  padding-right: 16px;
  height: max-content;
}
.personCellLayout .personNameLayout p{
  display: block;
  margin: auto 8px;
  overflow: hidden;
}
.personCellLayout .personSelectedLayout{
  float: right;
  position: relative;
  float: right;
  vertical-align: middle;
  margin-right: 12px;
  margin-top: 16px;
  margin-bottom: 16px;
}
.personCellLayout .personSelectedLayout button{
  height: 30px;
  width: 60px;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 6px;
  padding: 4px 12px;
}
.singleLineLayout{
  width: 100%;
  height: 1px;
  background-color: #f6f6f6;
}
.confirmButtonLayout{
  margin-top:0.48rem;
  padding-left:0;
  padding-right:0;
}
.pop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    overflow: auto;
}
</style>
